// "Newest" sorts by each listing's sort date (metadata.sortDate): when it was first published, or
// last renewed by the seller. See server/api-util/listingSortDate.js.
export const NEWEST_SORT = 'meta_sortDate';
export const OLDEST_SORT = '-meta_sortDate';

// Older links and saved searches still use the createdAt keys
const LEGACY_SORTS = { createdAt: NEWEST_SORT, '-createdAt': OLDEST_SORT };

/**
 * The sort to send to the Marketplace API. Without a chosen sort, results are newest first,
 * except keyword searches, which keep their relevance order.
 */
export const resolveListingSort = (sort, { hasKeywords = false } = {}) => {
  if (sort) {
    return LEGACY_SORTS[sort] || sort;
  }
  return hasKeywords ? null : NEWEST_SORT;
};
